/**
 * Централизованное логирование. Включение/выключение через config.json поле "logging".
 */
let enabled = false;

export function setLoggingEnabled(value: boolean): void {
    enabled = value;
}

export function isLoggingEnabled(): boolean {
    return enabled;
}

export function log(tag: string, message: string, data?: unknown): void {
    if (!enabled) return;
    if (data !== undefined) {
        console.log(`[${tag}] ${message}`, data);
    } else {
        console.log(`[${tag}] ${message}`);
    }
}

export function warn(tag: string, message: string, data?: unknown): void {
    if (!enabled) return;
    if (data !== undefined) {
        console.warn(`[${tag}] ${message}`, data);
    } else {
        console.warn(`[${tag}] ${message}`);
    }
}

export function error(tag: string, message: string, data?: unknown): void {
    if (!enabled) return;
    if (data !== undefined) {
        console.error(`[${tag}] ${message}`, data);
    } else {
        console.error(`[${tag}] ${message}`);
    }
}
